import { number, string, table } from "@rocicorp/zero";

export const ticket = table("tickets")
	.columns({
		id: string(),
		orgId: string().from("org_id"),
		projectId: string().from("project_id"),
		description: string(),
		type: string(),
		state: string(),
		number: string(),
		startDate: number().from("start_date").optional(),
		endDate: number().from("end_date").optional(),
	})
	.primaryKey("id");
